































































































































import {
  AtendimentoService,
  FormAtendimentoEnvio,
} from "@/services/atendimento.service";
import DateRange from "@/shared/components/date-range.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";
import dayjs from "dayjs";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Dictionary, Route } from "vue-router/types/router";
import ComboMotivoFechamento from "./ComboMotivoFechamento.vue";
import ComboTipoAtendimento from "./ComboTipoAtendimento.vue";
import ComboUsarioResponsavel from "@/shared/components/ComboUsarioResponsavel.vue";

class AtendimentoEnvio implements FormAtendimentoEnvio {
  numero = null;
  periodo = `${dayjs()
    .subtract(1, "year")
    .format("DD/MM/YYYY")} - ${dayjs().format("DD/MM/YYYY")}`;
  tipo = null;
  motivoFechamento = null;
  emailCliente = "";
  aberto = "true";
  possuiDataAtendimento = null;
  nomeCliente = "";
  telefoneCliente = "";
  idUsuario = "";
  offset = "0";
  limit = "100";
  order = "";

  constructor(idUsuario?: string) {
    if (idUsuario !== undefined) {
      this.idUsuario = idUsuario;
    }
  }
}

@Component({
  components: {
    DateRange,
    ComboTipoAtendimento,
    ComboMotivoFechamento,
    ComboUsarioResponsavel,
  },
})
export default class Filtro extends Vue {
  msgFiltro = "Mostrar Filtros";
  formAtivo: number | null = null;
  atendimento: FormAtendimentoEnvio | null = null;

  abertoItems = [
    { text: "", value: null },
    { text: "Apenas abertos", value: "true" },
    { text: "Apenas fechados", value: "false" },
  ];

  dataAtendimentoItems = [
    { text: "", value: null },
    { text: "Com data", value: "true" },
    { text: "Sem data", value: "false" },
  ];

  @Prop({ default: null }) readonly options!: ServerPageOptions | null;

  async mounted() {
    await this.onRouteChange(this.$route);
  }

  @Watch("$route")
  async onRouteChange(val: Route) {
    let contemDados = false;
    for (const a in val.query) {
      contemDados = a != undefined;
      break;
    }

    if (contemDados) {
      if (!this.atendimento) this.atendimento = new AtendimentoEnvio();

      this.atendimento.numero = "" + (val.query["numero"] ?? "");
      this.atendimento.periodo = "" + (val.query["periodo"] ?? "");
      this.atendimento.offset = "" + (val.query["offset"] ?? "");
      this.atendimento.limit = "" + (val.query["limit"] ?? "");
      this.atendimento.order = "" + (val.query["order"] ?? "");
      this.atendimento.tipo = "" + (val.query["tipo"] ?? "");
      this.atendimento.motivoFechamento =
        "" + (val.query["motivoFechamento"] ?? "");
      this.atendimento.emailCliente = "" + (val.query["emailCliente"] ?? "");
      this.atendimento.aberto = "" + (val.query["aberto"] ?? "");
      this.atendimento.possuiDataAtendimento =
        "" + (val.query["possuiDataAtendimento"] ?? "");
      this.atendimento.nomeCliente = "" + (val.query["nomeCliente"] ?? "");
      this.atendimento.telefoneCliente =
        "" + (val.query["telefoneCliente"] ?? "");
      this.atendimento.idUsuario = "" + (val.query["idUsuario"] ?? "");
      this.msgFiltro = "Fechar Filtros";
      this.formAtivo = 0;
    } else {
      await this.padrao();
      this.emitirAtendimento();
    }
  }

  @Watch("options")
  onOptionChange(to: ServerPageOptions | null) {
    if (to && this.atendimento) {
      Object.assign(this.atendimento, to);

      //Salvar a alteração do datatable na url
      this.fetchAtendimento(false);
    }
  }

  //Ao pesquisar voltar para a página 1 e salvar configurações na url
  fetchAtendimento(zerarPagina = true) {
    if (this.atendimento) {
      if (zerarPagina) {
        this.atendimento.offset = "0";
      }

      this.$router
        .replace({
          name: "Atendimentos",
          query: this.atendimento as Dictionary<any>,
        })
        .catch(() => console.log("Erro ignorado"));

      this.emitirAtendimento();
    }
  }

  limpaForm() {
    const form = this.$refs.form as any;
    form.reset();
  }

  async padrao() {
    this.atendimento = new AtendimentoEnvio(
      (await AtendimentoService.ObterUsuarioLogado()).toString()
    );
    this.fetchAtendimento();
  }

  changeMsgPanel() {
    if (this.msgFiltro == "Mostrar Filtros") {
      this.msgFiltro = "Fechar Filtros";
    } else {
      this.msgFiltro = "Mostrar Filtros";
    }
  }

  emitirAtendimento() {
    if (this.atendimento)
      this.$emit("onSubmit", AtendimentoService.Lista(this.atendimento));
  }
}
